<ng-container *ngIf="configuration; else cmsDisabled">
  <br-page [configuration]="configuration" [mapping]="mapping" [page]="pageModel">
    <ng-template let-page="page">
    <div class="content">
      <ng-container brComponent="main"></ng-container>
      <ng-container brComponent="loyalty-editable"></ng-container>
      <div class="help-center-wrapper">
        <ng-container brComponent="breadcrumb"></ng-container>
        <div class="help-center">
          <div class="help-center-left">
            <ng-container brComponent="left"></ng-container>
          </div>
          <div class="help-center-right">
            <ng-container brComponent="right"></ng-container>
          </div>
        </div>
      </div>
    </div>
    <ngx-loading [show]="dataService.loaderSubject | async" [config]="{ backdropBorderRadius: '14px',fullScreenBackdrop:true }"></ngx-loading>
    </ng-template>
  </br-page>
</ng-container>

<ng-template #cmsDisabled>
  <div class="content">
    <div class="help-center-wrapper">
      <div class="help-center">
        <div class="help-center-left">
          <div style="padding: 2rem; text-align: center;">
            <h1>Service Temporarily Unavailable</h1>
            <p style="margin-top: 1rem; color: #666;">The content management system is currently unavailable. Please try again later.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
